export default "__VITE_ASSET__6b9f744b__"